module.exports = __webpack_public_path__ + "img/img_start_1.f753a966.png";